/**
 * APP IDENTITY — the one place to change the product name and bundle id.
 *
 * `bundleId` is the reverse-domain identifier used by the App Store and
 * Play Store. It does NOT have to be a real domain, but it can NEVER be
 * changed after the first store release. Everything else here is free to
 * change at any time.
 *
 * Name locked 2026-09-22. bundleId changed 2026-09-23 to app.readybreak
 * (com.readybreak.app was already taken on Apple) and registered under
 * Team TDC36V4UKT. bundleId is PERMANENT after the
 * first store release — do not change it.
 */
export const APP = {
  name: 'Ready Break',
  shortName: 'Ready Break',
  description: 'Practice planner, playbook and attendance for football coaches',
  bundleId: 'app.readybreak',
  version: '3.0.0-dev',
} as const;
